<template>
  <div v-html="objective"></div>
</template>
<script>
import { } from 'mdbvue';
export default {
  name: 'TrainingObjective',
  props: ['objective']
}
</script>
